import styled from "styled-components";
import {subduedTextColour, triggerColour} from "../../style/styleConsts";
import HoverTarget from "../elements/HoverTarget";

export default styled(HoverTarget)`
    display: flex;
    
    .date {
        color: ${subduedTextColour};
    }

    :hover {
        background-color: ${triggerColour};
        color: white;

        .date {
            color: white;
        }
    }
`
